export default () => ({
	legacy: false,
	fallbackLocale: "en-US",
	silentTranslationWarn: false,
	missingWarn: false,
	silentFallbackWarn: false,
	fallbackWarn: false,
	// Ensure proper message format handling in production
	compilation: {
		strictMessage: false,
		escapeHtml: false
	}
});
